var exports = {
  "U": "x31de4314--0c4f48--buttons",
};

module.exports = exports;
